import { render, staticRenderFns } from "./BuyCrypto.vue?vue&type=template&id=56eb571c"
import script from "./BuyCrypto.vue?vue&type=script&lang=js"
export * from "./BuyCrypto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports